import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import classNames from "classnames";

import "./_style.scss";
import AccordionElement from "./element";

const Accordion = (props) => {
  const elements = props.children;
  const [openSet, setOpenSet] = useState([]);

  useEffect(() => {
    elements.forEach((item) => {
      if (item.props.open) {
        setOpenSet((openSet) => [...openSet, item.props.id]);
      }
    });
  }, [elements]);

  const openToggle = (id) => {
    let newOpenSet = openSet;
    if (openSet.includes(id)) {
      newOpenSet.splice(openSet.indexOf(id), 1);
      setOpenSet(newOpenSet);
    } else {
      if (props.autoClose === true) {
        newOpenSet = [id];
      } else {
        newOpenSet.push(id);
      }

      setOpenSet(newOpenSet);
    }
  };

  const AccordionList = ({ elements }) =>
    elements.map((item, key) => (
      <AccordionElement
        key={key}
        id={item.props.id}
        title_text={item.props.title_text}
        open={openSet.includes(item.props.id)}
        openToggle={openToggle}
      >
        {item.props.children}
      </AccordionElement>
    ));

  return (
    <div
      className={classNames({
        "accordion-container": true,
      })}
    >
      <AccordionList elements={elements} />
    </div>
  );
};

Accordion.propTypes = {
  autoClose: PropTypes.bool,
};

Accordion.defaultProps = {
  autoClose: true,
};
export default Accordion;
